export default __webpack_public_path__ + "static/media/zoologyLabImage.47e447d5.png";